import { useEffect, useState } from 'react'
import { useRouter } from '../../hooks/router';
import { verify_code } from "../../server/requests";
import { translateWord } from "../Util/util";

import ErrorMessage from "../AlertMessage/AlertMessage";
import Loading from "../Loading/Loading";

export default function VerifyCode({ setPopUpTitles }) {
    const router = useRouter()

    const [inputs, setInputs] = useState([
        { id: 0, value: '', default_val: '', active: true },
        { id: 1, value: '', default_val: '', active: false },
        { id: 2, value: '', default_val: '', active: false },
        { id: 3, value: '', default_val: '', active: false },
        { id: 4, value: '', default_val: '', active: false },
        { id: 5, value: '', default_val: '', active: false }
    ])

    const [alertMessage, setAlertMessage] = useState({
        type: 'error',
        show: false,
        text: ''
    })
    const [showLoading, setShowLoading] = useState(false)

    useEffect(() => {

        setPopUpTitles('We sent an activation link to email addres you have entered. Please check your email.')

        if (router.pathname.indexOf('verify-code') != -1) document.onkeyup = onKeyPressVerify

        else document.onkeyup = () => { }

    }, [router.query])


    const request_verify_pin = (pin) => {

        console.log(pin, 'pin')
        // verify_root(body, data => {
        //     localStorage.setItem('token', data)
        //     refresh_pin()
        //     if (router.pathname === '/' || router.pathname.indexOf('player') != -1) {
        //         setShowProtectedField(false)
        //         callBackIsProtected(router.query.id)
        //     } else router.push('/')
        // }, err => {
        //     refresh_pin()
        //     setAlertMessage({
        //         type: 'error',
        //         text: translateWord(err),
        //         show: true
        //     })
        // })

        verify_code({ code: pin }, data => {
            console.log(data)
            if (router.query.n == 'register') {
                router.push('/auth/sign-up?code=' + pin)
            } else {
                router.push('/auth/reset-password?code=' + pin)
            }
            refresh_pin()

        }, err => {
            console.log(err, 'asdasd code')
            refresh_pin()
            setAlertMessage({
                type: 'error',
                text: translateWord(err),
                show: true
            })
        })
    }


    function onKeyPressVerify(e) {
        if (e.key === 'Backspace') {
            const x = inputs.find(k => k.active === true)
            if (x) {
                let newArray = inputs

                if (newArray[newArray.indexOf(x) - 1]) {
                    x.active = false
                    newArray[newArray.indexOf(x) - 1].active = false
                    newArray[newArray.indexOf(x) - 1].default_val = ''
                    newArray[newArray.indexOf(x) - 1].value = ''
                    newArray[newArray.indexOf(x) - 1].active = true
                }
                setInputs([...newArray])
            }
        } else {

            const x = inputs.find(k => k.active === true)
            if (x) {
                x.default_val = ''
                x.value = ''
                x.value = e.key
                x.default_val = '*'
                x.active = false
            }

            let newArray = inputs
            if (newArray.indexOf(x) + 1 !== inputs.length) {
                newArray[newArray.indexOf(x) + 1].active = true
            } else {
                setShowLoading(true)
                let pin = []
                inputs.forEach(e => pin.push(e.value))
                document.onkeyup = function () { }
                request_verify_pin(pin.join(''))


            }

            setInputs([...newArray])

        }
    }

    const refresh_pin = () => {
        document.onkeyup = onKeyPressVerify
        let newArray = inputs
        newArray.forEach(e => {
            e.value = ''
            e.default_val = ""
            e.active = false
            if (e.id === 0) e.active = true
        })
        setAlertMessage(k => ({ ...k, show: false }))
        setShowLoading(false)
    }

    const btn_verify_pin = (e) => {

        if (!e.value) return

        let x = inputs.find(k => k.active === true)
        x.active = false
        e.active = true

        let newArray = inputs
        setInputs([...newArray])
    }

    return (
        <div className="parent_verify_pin">
            {showLoading ? <Loading /> : null}

            <ErrorMessage type={alertMessage.type} show={`${alertMessage.show}`} text={alertMessage.text} />

            <div className="fields fields_code">
                {
                    inputs.map(e => {
                        return (
                            <div key={e.id} className={e.active ? 'field_verify field_verify_code active' : 'field_verify field_verify_code'}>
                                <input
                                    type='text'
                                    autoFocus={e.id === 0 ? true : false}
                                    style={{ backgroundColor: e.value.length ? ' #38334D' : 'white' }}
                                    onClick={() => btn_verify_pin(e)}
                                    className={'field_verify_inp'}
                                    value={e.value}
                                />
                            </div>
                        )
                    })
                }
            </div>


        </div>
    )
} 